<div class="container-fluid">
    <h2 mat-dialog-title>Create League</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content class="dialong-content-100vh">
            <div class="container-fluid">
                <!-- League Information -->
                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>League Name</mat-label>
                            <input required matInput name="name" id="name" placeholder="League Name" type="text"
                                formControlName="name" />
                            <mat-error *ngIf="form.get('name').errors?.required">League Name is required</mat-error>
                            <mat-error *ngIf="form.get('name').errors?.validationErrors">
                                {{ form.get("name").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Description</mat-label>
                            <textarea matInput name="description" id="description" placeholder="Description (optional)"
                                rows="3" formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Create Initial Iteration Toggle -->
                <div class="row mt-3">
                    <div class="col-12">
                        <mat-slide-toggle [(ngModel)]="createInitialIteration"
                            [ngModelOptions]="{standalone: true}">
                            Create Initial Iteration
                        </mat-slide-toggle>
                        <p class="text-muted small mt-2">Create the first season/year for this league immediately</p>
                    </div>
                </div>

                <!-- Initial Iteration Form -->
                <div class="row" *ngIf="createInitialIteration" [formGroup]="iterationForm">
                    <div class="col-12">
                        <hr class="my-4">
                        <h3 class="mat-h3 mb-3">Initial Iteration Details</h3>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Year</mat-label>
                            <input required matInput name="year" id="year" type="number" formControlName="year"
                                [min]="2000" [max]="2100" />
                            <mat-error *ngIf="iterationForm.get('year').errors?.required">Year is required</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Entry Fee</mat-label>
                            <input required matInput name="entryFee" id="entryFee" type="number"
                                placeholder="0.00" formControlName="entryFee" [min]="0" step="0.01" />
                            <span matPrefix>$&nbsp;</span>
                            <mat-error *ngIf="iterationForm.get('entryFee').errors?.required">Entry Fee is required
                            </mat-error>
                            <mat-error *ngIf="iterationForm.get('entryFee').errors?.min">Entry Fee must be 0 or greater
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Start Date</mat-label>
                            <input required matInput [matDatepicker]="startPicker" formControlName="startDateOnly" />
                            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                            <mat-error *ngIf="iterationForm.get('startDateOnly').errors?.required">Start Date is required
                            </mat-error>
                            <mat-error *ngIf="iterationForm.get('startDateOnly').errors?.validationErrors">
                                {{ iterationForm.get("startDateOnly").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>End Date</mat-label>
                            <input required matInput [matDatepicker]="endPicker" formControlName="endDateOnly" />
                            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                            <mat-error *ngIf="iterationForm.get('endDateOnly').errors?.required">End Date is required
                            </mat-error>
                            <mat-error *ngIf="iterationForm.get('endDateOnly').errors?.validationErrors">
                                {{ iterationForm.get("endDateOnly").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>Start Time</mat-label>
                            <input required matInput [matTimepicker]="startTimePicker" formControlName="startTimeOnly" />
                            <mat-timepicker #startTimePicker/>
                            <mat-timepicker-toggle [for]="startTimePicker" matSuffix/>
                            <mat-error *ngIf="iterationForm.get('startTimeOnly').errors?.required">Start Time is required
                            </mat-error>
                            <mat-error *ngIf="iterationForm.get('startTimeOnly').errors?.validationErrors">
                                {{ iterationForm.get("startTimeOnly").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>End Time</mat-label>
                            <input required matInput [matTimepicker]="endTimePicker" formControlName="endTimeOnly" />
                            <mat-timepicker #endTimePicker/>
                            <mat-timepicker-toggle [for]="endTimePicker" matSuffix/>
                            <mat-error *ngIf="iterationForm.get('endTimeOnly').errors?.required">End Time is required
                            </mat-error>
                            <mat-error *ngIf="iterationForm.get('endTimeOnly').errors?.validationErrors">
                                {{ iterationForm.get("endTimeOnly").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Notes</mat-label>
                            <textarea matInput name="notes" id="notes" placeholder="Notes (optional)" rows="2"
                                formControlName="notes"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading || (createInitialIteration && !iterationForm.valid)">
                    Save
                </button>
                <button mat-raised-button class="warning" (click)="dialogRef.close('cancel')" [disabled]="isLoading">
                    Cancel
                </button>
            </div>
        </mat-dialog-actions>
    </form>
</div>

